import { t } from "@redotech/redo-i18n";
import { Condition as ModelCondition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  totalSpentGreaterThanFromModel,
  validateTotalSpentGreaterThanCondition,
  type TotalSpentGreaterThanState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const TOTAL_SPENT_GREATER_THAN = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<TotalSpentGreaterThanState>
  >,
): ConditionType<
  TotalSpentGreaterThanState,
  ModelCondition.TotalSpentGreaterThan
> => ({
  name: CONDITION_NAMES[ModelCondition.TOTAL_SPENT_GREATER_THAN],
  description(state) {
    return t("More than ${{amount}} spent", { amount: +state });
  },
  Details(props: ConditionTypeDetailsProps<TotalSpentGreaterThanState>) {
    return React.createElement(Details, props);
  },
  empty: String(0),
  fromModel(model) {
    return totalSpentGreaterThanFromModel(model);
  },
  toModel(state) {
    return { type: ModelCondition.TOTAL_SPENT_GREATER_THAN, totalSpent: state };
  },
  valid(state) {
    return validateTotalSpentGreaterThanCondition(state).valid;
  },
});
